// Generated by purs version 0.13.0
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Argonaut_Core = require("../Data.Argonaut.Core/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Combinators = require("../Data.Argonaut.Decode.Combinators/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Argonaut_Encode_Combinators = require("../Data.Argonaut.Encode.Combinators/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Show = require("../Data.Show/index.js");
var Ritoppu_Model_CreatureType = require("../Ritoppu.Model.CreatureType/index.js");
var Ritoppu_Model_Equipment = require("../Ritoppu.Model.Equipment/index.js");
var Corpse = (function () {
    function Corpse(value0) {
        this.value0 = value0;
    };
    Corpse.create = function (value0) {
        return new Corpse(value0);
    };
    return Corpse;
})();
var HealingPotion = (function () {
    function HealingPotion() {

    };
    HealingPotion.value = new HealingPotion();
    return HealingPotion;
})();
var LightningScroll = (function () {
    function LightningScroll() {

    };
    LightningScroll.value = new LightningScroll();
    return LightningScroll;
})();
var FireballScroll = (function () {
    function FireballScroll() {

    };
    FireballScroll.value = new FireballScroll();
    return FireballScroll;
})();
var ConfusionScroll = (function () {
    function ConfusionScroll() {

    };
    ConfusionScroll.value = new ConfusionScroll();
    return ConfusionScroll;
})();
var MainHandItem = (function () {
    function MainHandItem(value0) {
        this.value0 = value0;
    };
    MainHandItem.create = function (value0) {
        return new MainHandItem(value0);
    };
    return MainHandItem;
})();
var OffHandItem = (function () {
    function OffHandItem(value0) {
        this.value0 = value0;
    };
    OffHandItem.create = function (value0) {
        return new OffHandItem(value0);
    };
    return OffHandItem;
})();
var newCorpse = function (creature) {
    return new Corpse(creature.type);
};
var itemName = function (v) {
    if (v instanceof Corpse) {
        return "Corpse of " + Data_Show.show(Ritoppu_Model_CreatureType.showCreatureType)(v.value0);
    };
    if (v instanceof HealingPotion) {
        return "Healing potion";
    };
    if (v instanceof LightningScroll) {
        return "Lightning Scroll";
    };
    if (v instanceof FireballScroll) {
        return "Fireball Scroll";
    };
    if (v instanceof ConfusionScroll) {
        return "Confusion Scroll";
    };
    if (v instanceof MainHandItem) {
        return Data_Show.show(Ritoppu_Model_Equipment.showMainHandItem)(v.value0);
    };
    if (v instanceof OffHandItem) {
        return Data_Show.show(Ritoppu_Model_Equipment.showOffHandItem)(v.value0);
    };
    throw new Error("Failed pattern match at Ritoppu.Model.Item (line 30, column 12 - line 37, column 46): " + [ v.constructor.name ]);
};
var eqItem = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Corpse && y instanceof Corpse) {
            return Data_Eq.eq(Ritoppu_Model_CreatureType.eqCreatureType)(x.value0)(y.value0);
        };
        if (x instanceof HealingPotion && y instanceof HealingPotion) {
            return true;
        };
        if (x instanceof LightningScroll && y instanceof LightningScroll) {
            return true;
        };
        if (x instanceof FireballScroll && y instanceof FireballScroll) {
            return true;
        };
        if (x instanceof ConfusionScroll && y instanceof ConfusionScroll) {
            return true;
        };
        if (x instanceof MainHandItem && y instanceof MainHandItem) {
            return Data_Eq.eq(Ritoppu_Model_Equipment.eqMainHandItem)(x.value0)(y.value0);
        };
        if (x instanceof OffHandItem && y instanceof OffHandItem) {
            return Data_Eq.eq(Ritoppu_Model_Equipment.eqOffHandItem)(x.value0)(y.value0);
        };
        return false;
    };
});
var ordItem = new Data_Ord.Ord(function () {
    return eqItem;
}, function (x) {
    return function (y) {
        if (x instanceof Corpse && y instanceof Corpse) {
            return Data_Ord.compare(Ritoppu_Model_CreatureType.ordCreatureType)(x.value0)(y.value0);
        };
        if (x instanceof Corpse) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Corpse) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof HealingPotion && y instanceof HealingPotion) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof HealingPotion) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof HealingPotion) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof LightningScroll && y instanceof LightningScroll) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof LightningScroll) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof LightningScroll) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof FireballScroll && y instanceof FireballScroll) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof FireballScroll) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof FireballScroll) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof ConfusionScroll && y instanceof ConfusionScroll) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof ConfusionScroll) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof ConfusionScroll) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof MainHandItem && y instanceof MainHandItem) {
            return Data_Ord.compare(Ritoppu_Model_Equipment.ordMainHandItem)(x.value0)(y.value0);
        };
        if (x instanceof MainHandItem) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof MainHandItem) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof OffHandItem && y instanceof OffHandItem) {
            return Data_Ord.compare(Ritoppu_Model_Equipment.ordOffHandItem)(x.value0)(y.value0);
        };
        throw new Error("Failed pattern match at Ritoppu.Model.Item (line 40, column 1 - line 40, column 36): " + [ x.constructor.name, y.constructor.name ]);
    };
});
var encodeJsonItem = new Data_Argonaut_Encode_Class.EncodeJson(function (v) {
    if (v instanceof Corpse) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("item")("Corpse"))(Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Ritoppu_Model_CreatureType.encodeJsonCreatureType)("CreatureType")(v.value0))(Data_Argonaut_Core.jsonEmptyObject));
    };
    if (v instanceof HealingPotion) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("item")("HealingPotion"))(Data_Argonaut_Core.jsonEmptyObject);
    };
    if (v instanceof LightningScroll) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("item")("LightningScroll"))(Data_Argonaut_Core.jsonEmptyObject);
    };
    if (v instanceof FireballScroll) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("item")("FireballScroll"))(Data_Argonaut_Core.jsonEmptyObject);
    };
    if (v instanceof ConfusionScroll) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("item")("ConfusionScroll"))(Data_Argonaut_Core.jsonEmptyObject);
    };
    if (v instanceof MainHandItem) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("item")("MainHandItem"))(Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Ritoppu_Model_Equipment.encodeJsonMainHandItem)("MainHandItem")(v.value0))(Data_Argonaut_Core.jsonEmptyObject));
    };
    if (v instanceof OffHandItem) {
        return Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Data_Argonaut_Encode_Class.encodeJsonJString)("item")("OffHandItem"))(Data_Argonaut_Encode_Combinators.extend(Data_Argonaut_Encode_Class.encodeJsonJson)(Data_Argonaut_Encode_Combinators.assoc(Ritoppu_Model_Equipment.encodeJsonOffHandItem)("OffHandItem")(v.value0))(Data_Argonaut_Core.jsonEmptyObject));
    };
    throw new Error("Failed pattern match at Ritoppu.Model.Item (line 63, column 16 - line 87, column 27): " + [ v.constructor.name ]);
});
var decodeJsonItem = new Data_Argonaut_Decode_Class.DecodeJson(function (json) {
    return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeForeignObject(Data_Argonaut_Decode_Class.decodeJsonJson))(json))(function (v) {
        return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonString)(v)("item"))(function (v1) {
            if (v1 === "Corpse") {
                return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Ritoppu_Model_CreatureType.decodeJsonCreatureType)(v)("CreatureType"))(function (v2) {
                    return Control_Applicative.pure(Data_Either.applicativeEither)(new Corpse(v2));
                });
            };
            if (v1 === "MainHandItem") {
                return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Ritoppu_Model_Equipment.decodeJsonMainHandItem)(v)("MainHandItem"))(function (v2) {
                    return Control_Applicative.pure(Data_Either.applicativeEither)(new MainHandItem(v2));
                });
            };
            if (v1 === "OffHandItem") {
                return Control_Bind.bind(Data_Either.bindEither)(Data_Argonaut_Decode_Combinators.getField(Ritoppu_Model_Equipment.decodeJsonOffHandItem)(v)("OffHandItem"))(function (v2) {
                    return Control_Applicative.pure(Data_Either.applicativeEither)(new OffHandItem(v2));
                });
            };
            if (v1 === "HealingPotion") {
                return Control_Applicative.pure(Data_Either.applicativeEither)(HealingPotion.value);
            };
            if (v1 === "LightningScroll") {
                return Control_Applicative.pure(Data_Either.applicativeEither)(LightningScroll.value);
            };
            if (v1 === "FireballScroll") {
                return Control_Applicative.pure(Data_Either.applicativeEither)(FireballScroll.value);
            };
            if (v1 === "ConfusionScroll") {
                return Control_Applicative.pure(Data_Either.applicativeEither)(ConfusionScroll.value);
            };
            return new Data_Either.Left("Unknown Item " + v1);
        });
    });
});
module.exports = {
    Corpse: Corpse,
    HealingPotion: HealingPotion,
    LightningScroll: LightningScroll,
    FireballScroll: FireballScroll,
    ConfusionScroll: ConfusionScroll,
    MainHandItem: MainHandItem,
    OffHandItem: OffHandItem,
    newCorpse: newCorpse,
    itemName: itemName,
    eqItem: eqItem,
    ordItem: ordItem,
    decodeJsonItem: decodeJsonItem,
    encodeJsonItem: encodeJsonItem
};
